import { ck, cr, URLS } from "fire-wind-water";
import { getChannelParams } from "../../core/channel";

// 追加markCode
const markCode = URLS.getURL("markCode");
const marketing = [
  "api/marketing/task/query",
  "api/marketing/config/share/get",
  "customForm/view",
  "api/customform/browse",
  "customform/action",
  "member/Form/GetforNewform",
  "questionary/view",
  "api/questionnaire/browse",
  "questionary/action",
  "poll/view",
  "api/poll/browse",
  "poll/action",
  "api/luckydraw/browse",
  "luckydraw/view",
  "luckyDraw/client/action",
  "api/article/category/interaction/browse",
  "article/browse",
  "api/file/interaction/preview",
  "file/downloadWithEmail",
  "api/article/interaction/Create",
  "member/interaction/Record",
  "seminar/contact/RegisterNew",
  "api/customform/Share",
  "api.customform.Submit",
  "api/project/webinar/contacts/Login",
  "api/webinar/contacts/SignUp",
  "api/webinar/demand/Share",
  "api/webinar/demand/site/Browse",
  "api/webinar/live/Share",
  "api/webinar/live/site/Browse",
  "webinar/open/NewRegistration",
];

let urlAsReg: any = [];
cr.each(marketing, (d) => {
  urlAsReg.push("(" + d + ")");
});
urlAsReg = urlAsReg.join("|");

function addMarkCode(config) {
  const reg = new RegExp(urlAsReg, "i");
  if (reg.test(config.url) && markCode) {
    config.data.markCode = markCode;
  }
  return config;
}

// 追加mipToken
const miniMipToken = ["/member/login", "/member/register"];
const mipToken = ck.cookie("miniMipToken");
let mipAsReg: any = [];
cr.each(miniMipToken, (d) => {
  mipAsReg.push("(" + d + ")");
});
mipAsReg = mipAsReg.join("|");

function addMipToken(config) {
  const reg = new RegExp(mipAsReg);
  if (reg.test(config.url) && mipToken) {
    const m = mipToken.replace("bearer ", "");
    config.data.miniMipToken = m || null;
  }
  return config;
}
function addDataParams(config) {
  config.data.miniToken = ck.cookie("miniToken") || null;
  config.data.programType = ck.cookie("programType") || null;
  config.data.programId = ck.cookie("programId") || null;
  config.data.programUserId = ck.cookie("programUserId") || null;
  config.data.fromUserId = ck.cookie("fromUserId") || null;
  //if (!markCode || markCode == "null") {
    config.data.browseInfo = getChannelParams() || null;
  //}
  return config;
}

export { addMarkCode, addMipToken, addDataParams };
